<template>
  <div class="modal-section">
    <h4 class="mb-3">{{ title }}</h4>
    <slot />
  </div>
</template>

<script>
export default {
  name: "TModalSection",
  props: {
    title: {
      type: String,
      requried: true,
    },
  },
};
</script>
